export default __webpack_public_path__ + "static/media/logo-RGB.8b60b1ce.svg";